import React from 'react';
import { Breadcrumb, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useAppContext } from './AppContext';
import { HierarchyURL } from '../Config';

const EmployeeTree = ({ clickable }) => {
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedBreadcrumb, setSelectedBreadcrumb] = useState(null);
  const { upName, setMailID, setUpName, isAdmin,idToken } = useAppContext();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    //console.log('Click:', clickable);    
    //console.log('User Principal Name:', upName);

    fetch(HierarchyURL + `/${upName}`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`  // Include the bearer token here
      }
    })
      .then(response => response.json())
      .then(data => {
        setEmployeeData(data);
        setLoading(false);
      })
      .catch(error => {
        //console.error('Error fetching data:', error);
        setLoading(false);
      }
      );


  }, [upName]);

  const handleBreadcrumbClick = (item) => {
    if (clickable && isAdmin) {
      setSelectedBreadcrumb(item.userEmail);
      setUpName(item.userPrincipalName);
      setMailID(item.userEmail);
      // You can perform additional actions here when a breadcrumb is clicked
      //console.log(`Clicked on ${item.userName}`);
    }
  };


  const renderEmployeeTreeBreadCrumb = (data) => {
    // Reverse the order of the data array
    const reversedData = [...data].reverse();

    return reversedData.map((item, index) => {
      const isSelected = selectedBreadcrumb === item.userEmail;
      return {
        title: (
          <span
            key={item.userEmail}
            onClick={() => handleBreadcrumbClick(item)}
            style={{
              backgroundColor: isSelected ? 'grey' : 'transparent',
              color: isSelected ? 'white' : 'black',
              borderRadius: '4px',
              padding: '8px 12px',
              marginRight: '4px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            {item.userName}
          </span>
        ),
      };
    });
  }

  return (
    <Spin spinning={loading} size="large">
      <div style={{ padding: 8 }}>
        <Breadcrumb items={renderEmployeeTreeBreadCrumb(employeeData)} />
      </div>
    </Spin>
  );
};

export default EmployeeTree;
